export const PATHS = {
  HOME: "/",
  REGPAGE: "/business-registration",
  REWARDS: "/rewards",
  POLICY: "/privacy-policy",
  TERMS: "/terms-condition",
  BTERMS: "/business-registration-terms",
  DSA_AGREEMENT: "/dsa-agreement",
  DSA: "/dsa",
  APISERVICES: "/api-services",
  INVOICE: "/invoice",
  PAYMENT_LINK: "/payment-link",
  B_COMMERCE: "/b-commerce",
};
